<template>
  <div class="content contacto-bg contacto-fixed">
    <div class="container-fluid mt-5 mb-5">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <h3 class="text-warning">Para mayor información contáctanos</h3>          
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <div class="mt-3"></div>
          <hr />
          <!-- <p>
            <font-awesome-icon icon="phone" />
            +52 (55) 5555-5555
          </p> -->
          <p>
            <font-awesome-icon icon="envelope" />
            info@correduriadigital.mx
          </p>
          <p>
            <font-awesome-icon icon="building" />
            Av. Paseo de las Palmas, Oficina 204, Lomas de Chapultepec, CDMX, México
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactoComponent",
};
</script>

<style>
.contacto-bg {
  background-color: #f7f7f8;
}

/* Mantiene el componente pegado al fondo y ocupa el alto restante */
.contacto-fixed {
  min-height: 13vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>
